<template>
    <div class="body">
        <div class="bg"></div>
        <div class="content">
            <div class="back" @click="$router.go(-1)">
                <img src="../../assets/img/i19.png" />
                返回
            </div>
            <div class="top" id="oneChart"></div>
            <div class="center">
                <div class="c_tab" v-if="questionList.length > 0">
                    <el-button class="ct_item" :class="questionIndex == index ? 'cti':''" v-for="(item, index) in questionList"
                        :key="index" @click="btn_tab(item, index)">第{{ index + 1 }}题</el-button>
                </div>
                <div class="c_ques" v-if="questionItem && questionItem.questionContent">
                    <div class="cq_top">{{ questionItem.questionContent }}</div>
                    <div class="cq_center">
                        <div class="cqc_item" v-for="(item, index) in questionItem.techClassQuestionOpt" :key="index">
                            {{ item.optionNo }}：{{ item.optionContent }}</div>
                    </div>
                    <div class="cq_bottom">正确答案：<span
                            v-for="(item, index) in questionItem.techClassQuestionOpt.filter(opt => opt.optionAnswer == 1)"
                            :key="index">{{ item.optionNo }}</span> </div>
                </div>
                <div class="c_stu">
                    <!-- 
                        :height="'100%'" -->
                    <el-table :header-cell-style="{ background: '#F7F8FA' }" :data="list" style="width: 100%;">
                        <el-table-column label="序号" width="150">
                            <template slot-scope="scope">
                                <div>{{ scope.$index + 1 }}</div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="name" label="姓名" width="150"></el-table-column>
                        <el-table-column prop="stdNo" label="学号" width="150"></el-table-column>
                        <el-table-column prop="studentAnswer" label="答案">
                            <template slot-scope="scope">
                                <div class="line2_" style="height: 50px;cursor: pointer;" @click="btn_pop(scope.row)">{{
                                    scope.row.studentAnswer }}</div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="createTime" label="答题时间" width="150"></el-table-column>
                    </el-table>
                </div>
            </div>
        </div>
        <el-dialog title="答案" :visible.sync="dialogVisible" width="50%">
            <span>这是一段信息</span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>

import {
    questionHelperStatistics,
    questionGroupQuestionList,
    studentQuestionList
} from '@/apis/index'
export default {
    data() {
        return {
            list: [],
            id: this.$route.query.id,
            questionGroupId: this.$route.query.questionGroupId,
            questionList: [],
            questionIndex: 0,
            questionItem: {},
            questionId: '',
            dialogVisible: false,
            studentAnswer: ''
        }
    },
    mounted() {
        if (this.id) {
            this.getquestionHelperStatistics()
            if (this.questionGroupId) {
                this.getList()
            }
        }
    },
    methods: {
        btn_pop(row) {
            console.log(row);
            if (row.questionType == 4) {
                this.dialogVisible = true
                this.studentAnswer = row.studentAnswer
            }
        },
        getStudentQuestionList() {
            studentQuestionList(this.id, this.questionItem.id).then(res => {
                console.log(res, 'studentQuestionList')
                this.list = res.data
            })
        },
        btn_tab(item, index) {
            this.questionItem = item
            this.questionIndex = index
            this.getStudentQuestionList()
        },
        getList() {
            questionGroupQuestionList(this.questionGroupId, 1, 50).then(res => {
                console.log(res, 'questionGroupQuestionList');
                // if (this.pageNum == 1) {
                //     this.list = []
                // }
                // this.total = res.data.total
                this.questionList = res.data.list
                this.questionItem = this.questionList[0]
                this.getStudentQuestionList()
            })
        },
        getquestionHelperStatistics() {
            questionHelperStatistics(this.id).then(res => {
                console.log(res)
                this.initEcharts(res.data)
            })
        },
        initEcharts(data) {
            // data 是接口返回的数组
            const xData = data.map((item, index) => index + 1); // X轴：索引+1
            const yData = data.map(item => item.completeNum || 0); // Y轴：完成人数
            const errorData = data.map(item => item.errorNum || 0); // 错误人数
            const typeData = data.map(item => item.type); // 类型，用于判断是否显示正确率

            const option = {
                title: {
                    text: '题目统计',
                    left: 'left'
                },
                tooltip: {
                    trigger: 'axis',
                    axisPointer: { type: 'shadow' },
                    formatter: params => {
                        // params 是数组，取第一个柱状图数据
                        const idx = params[0].dataIndex;
                        const completeNum = yData[idx];
                        const errorNum = errorData[idx];
                        const type = typeData[idx];
                        // 题目序号: ${idx + 1}<br/>
                        let tooltipText = `完成人数: ${completeNum}<br/>错误人数: ${errorNum}`;

                        if (type != 4 && completeNum > 0) {
                            const correctRate = ((completeNum - errorNum) / completeNum * 100).toFixed(2);
                            tooltipText += `<br/>正确率: ${correctRate}%`;
                        }

                        return tooltipText;
                    }
                },
                grid: {
                    left: '5%',
                    // right: '10%',
                    top: 80,
                    // bottom: '15%'
                    width: '100%',
                    height: 210
                },
                xAxis: {
                    type: 'category',
                    data: xData,
                    axisTick: { alignWithLabel: true }
                },
                yAxis: {
                    type: 'value',
                    name: '完成人数'
                },
                series: [{
                    name: '完成人数',
                    type: 'bar',
                    barWidth: 20,
                    data: yData,
                    itemStyle: {
                        color: '#2992FF'
                    }
                }]
            };

            this.oneChart = this.$echarts.init(document.getElementById('oneChart'));
            this.oneChart.setOption(option);

            // 监听窗口大小变化，图表自适应
            window.addEventListener('resize', () => {
                this.oneChart.resize();
            });
        }
    }
}
</script>

<style lang="scss" scoped>
.line2_ {
    word-break: break-all;
    display: -webkit-box;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
}

.body {
    width: 100%;
    height: 100%;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    overflow-y: scroll;

    .content::-webkit-scrollbar {
        // display: none;
    }

    .content {
        width: 1200px;
        // height: 0;
        // flex: 1;
        display: flex;
        flex-direction: column;
        align-items: center;
        z-index: 1;

        .back {
            width: 100%;
            display: flex;
            align-items: center;
            font-weight: bold;
            font-size: 14px;
            color: #000000;
            margin-bottom: 10px;
            margin-top: 10px;
            cursor: pointer;

            img {
                width: 14px;
                height: 14px;

            }
        }

        .top {
            width: 100%;
            height: 310px;
            margin: 40px 0;
        }

        .center {
            width: 100%;

            .c_tab {
                width: 100%;
                display: flex;
                align-items: center;
                flex-wrap: wrap;

                .cti {
                    background: #2992FF !important;
                    color: #FFFFFF !important;
                }
                .cti{
                    color: #409eff !important;
                    background-color: #ecf5ff !important;
                    border-color: #c6e2ff !important;
                }
                .ct_item {
                    width: 89px;
                    margin-right: 10px;
                    margin-bottom: 20px;
                    // height: 34px;
                    // background: #FFFFFF;
                    // border-radius: 8px 8px 8px 8px;
                    // border: 1px solid #E9EBF2;
                    // font-weight: 500;
                    // font-size: 14px;
                    // color: #333333;
                    // text-align: center;
                    // line-height: 34px;
                }
            }

            .c_stu {
                width: 100%;
                // height: 500px;
                margin-top: 40px;
                margin-bottom: 40px;
            }

            .c_ques {
                width: 100%;

                .cq_top {
                    width: 100%;
                    font-weight: 500;
                    font-size: 16px;
                    color: #333333;
                    line-height: 28px;
                    margin-bottom: 20px;
                }

                .cq_center {
                    width: 100%;
                    display: flex;
                    align-items: center;
                    flex-wrap: wrap;

                    .cqc_item {
                        font-weight: 500;
                        font-size: 14px;
                        color: #666666;
                        margin-bottom: 10px;
                        margin-right: 10px;

                    }
                }

                .cq_bottom {
                    font-weight: 500;
                    font-size: 14px;
                    color: #666666;
                }
            }
        }

    }
}
</style>